import { ChevronLeftIcon, WordsHappenButton } from '@words-happen/ui-components';
import type React from 'react';
import { ScreenFrame } from '../screen-frame';
import styles from './lobby-screen.module.scss';

export interface LobbyFrameProps {
  title: string;
  /** Names the back control, e.g. "Back to home". */
  backLabel: string;
  onBack: () => void;
  /** Beside the title, which stays in view as the page scrolls: e.g. a + button. */
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/** A lobby screen's frame: the back control, then the title (pinned while the page scrolls) and the content. */
export const LobbyFrame: React.FC<LobbyFrameProps> = ({ title, backLabel, onBack, action, children, className }) => (
  <ScreenFrame className={className}>
    <header className={styles.topBar}>
      <WordsHappenButton
        size="sm"
        className={styles.back}
        aria-label={backLabel}
        icon={<ChevronLeftIcon size={22} />}
        onClick={onBack}
      />
    </header>
    <main className={styles.main}>
      <div className={styles.titleRow}>
        <h1 className={styles.title}>{title}</h1>
        {action}
      </div>
      {children}
    </main>
  </ScreenFrame>
);
